import Plyr from 'plyr';
import { CookieModule } from './cookie.module';
import Cookies from 'js-cookie';
import { BaseModule } from './base.module';

export class VideoPlayerModule extends BaseModule {
	constructor(configuration = null) {
		super();
		this.videoSelector = '.player';
		this.importPlayerImmediately = true;
		this.configuration = {
			// iconUrl: './plyr.svg'
			storage: {
				enabled: false,
			},
		};
		this.autoPlayConfig = {
			autoplay: true,
			muted: true,
			volume: 0,
		};
		if (configuration) {
			this.configuration = Object.assign(this.configuration, configuration);
		}
		if (typeof window !== 'undefined' && window.videoPlayerModuleConfiguration) {
			this.configuration = Object.assign(this.configuration, window.videoPlayerModuleConfiguration);
		}
	}

	setEventListeners() {
		import('plyr').then((module) => {
			// console.log('imported plyr module');
			let videos = document.querySelectorAll(this.videoSelector);
			document.addEventListener('cookie-module-loaded', (event) => {
				// console.log('video player cookie-module-loaded event listener', event);
				this.setVideoPlaceholders(videos, module, event);
				document.addEventListener('revoke-cookie-choice', (event) => {
					this.setVideoPlaceholders(videos, module, event);
					event.data.module.addEventListeners();
				});
				document.addEventListener('non-functional-cookies-accepted', () => {
					videos.forEach((video) => {
						let usesNonFunctionalCookies = null;
						video.innerHTML = ``; // empty it
						if (typeof video.dataset !== 'undefined' && typeof video.dataset.usesNonFunctionalCookies !== 'undefined') {
							usesNonFunctionalCookies = parseInt(video.dataset.usesNonFunctionalCookies);
							if (usesNonFunctionalCookies == true) {
								video.innerHTML = ``; // empty
								let id = '#' + video.getAttribute('id');
								let p = new module.default(id, this.configuration);
							}
						}
					});
				});
			});
		});
	}

	/**
	 * 
	 * @param {} videos 
	 * @param {Plyr} module 
	 */
	setVideoPlaceholders(videos, module, event) {
		// console.log('setVideoPlaceholders', videos, module);
		videos.forEach((video) => {
			let usesNonFunctionalCookies = null;
			if (typeof video.dataset !== 'undefined' && typeof video.dataset.usesNonFunctionalCookies !== 'undefined') {
				usesNonFunctionalCookies = parseInt(video.dataset.usesNonFunctionalCookies);
				if (usesNonFunctionalCookies == false) {
					let id = '#' + video.getAttribute('id');
					let p = new module.default(id, this.configuration);
				} else {
					if (usesNonFunctionalCookies == true) {
						// console.log('found an embed that uses non-functional cookies', video);
						// console.log('has needed permission? =>', event.data.module.hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes);
						if (
							typeof event !== 'undefined' &&
							typeof event.data != 'undefined' &&
							typeof event.data.module != 'undefined' &&
							typeof event.data.module.cookiesEnablerConfiguration !== 'undefined' &&
							typeof event.data.module.cookiesEnablerConfiguration.iframesPlaceholderHTML !== 'undefined' &&
							event.data.module.googleTransparenceAndConsentFrameworkApplicationProgrammingInterfaceUsed === true &&
							event.data.module.hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes === false
						) {
							let div = document.createElement('div');
							div.innerHTML = `${event.data.module.cookiesEnablerConfiguration.iframesPlaceholderHTML}`;
							video.innerHTML = ``; // reset...
							video.appendChild(div);
							event.data.module.addEventListeners();
						}
						if (
							typeof event !== 'undefined' &&
							typeof event.data != 'undefined' &&
							typeof event.data.module != 'undefined' &&
							typeof event.data.module.cookiesEnablerConfiguration !== 'undefined' &&
							typeof event.data.module.cookiesEnablerConfiguration.iframesPlaceholderHTML !== 'undefined' &&
							event.data.module.googleTransparenceAndConsentFrameworkApplicationProgrammingInterfaceUsed === false
							&&
							(
								parseInt(Cookies.get('ckaccept')) === 0 ||
								typeof Cookies.get('ckaccept') === 'undefined'
							)
						) {
							let div = document.createElement('div');
							div.innerHTML = `${event.data.module.cookiesEnablerConfiguration.iframesPlaceholderHTML}`;
							video.innerHTML = ``; // reset...
							video.appendChild(div);
						}

						if (
							typeof event !== 'undefined' &&
							typeof event.data != 'undefined' &&
							typeof event.data.module != 'undefined' &&
							typeof event.data.module.cookiesEnablerConfiguration !== 'undefined' &&
							typeof event.data.module.cookiesEnablerConfiguration.iframesPlaceholderHTML !== 'undefined' &&
							event.data.module.googleTransparenceAndConsentFrameworkApplicationProgrammingInterfaceUsed === false
							&&
							(
								parseInt(Cookies.get('ckaccept')) === 1
							)
						) {
							this.triggerEventOnElement('non-functional-cookies-accepted', document, { module: event.data.module });
							import('plyr').then((module) => {
								let id = '#' + video.getAttribute('id');
								let p = new module.default(id, this.configuration);
							});
						}
					}
				}
			}
		});
	}

	initialize() {
		if (typeof document !== 'undefined') {
			this.setEventListeners();

			let videos = document.querySelectorAll(this.videoSelector);
			if (videos && videos.length > 0 || this.importPlayerImmediately === true) {
				this.importPlayer(videos);
			}
		}
	}

	importPlayer(videos) {
		import('plyr').then((module) => {
			videos.forEach((video) => {
				const playerHasAutoplay = video.dataset.autoplay === 'true';
				const configuration = playerHasAutoplay ? Object.assign({}, this.configuration, this.autoPlayConfig) : this.configuration;

				let usesNonFunctionalCookies = null;
				if (typeof video.dataset !== 'undefined' && typeof video.dataset.usesNonFunctionalCookies !== 'undefined') {
					usesNonFunctionalCookies = parseInt(video.dataset.usesNonFunctionalCookies);
					// console.log('usesNonFunctionalCookies', usesNonFunctionalCookies);
					// truthy based on integer cast "0" || "1" attribute value
					if (usesNonFunctionalCookies == true) {
						// console.log('video', video, 'uses a platform that uses non-functional cookies, waiting for acceptance');
					}
				}
				// falsey based on integer cast "0" || "1" attribute value, or fallback if no dataset
				if (usesNonFunctionalCookies == false || usesNonFunctionalCookies === null) {
					let id = '#' + video.getAttribute('id');
					let p = new module.default(id, configuration);
				}
			});
		});
	}
}